/**
 * Created by rudi on 07/02/14.
 */

OLIVIO.cmodel = (function () {
  var pub = {};

  pub.product = OLIVIO.PRODUCT_SISTEMA;

  // TODO get initial values from Data
  pub.mastSizesmm = [12000, 11000, 10000, 9000, 8000, 7000, 6000, 5000];
  pub.mastSizeChangeable = false;
  pub.mastDiametermm = ['108/230', '108/220', '89/201', '89/190', '89/179', '89/168', '89/157', '89/146'];

  pub.mastHeightWorldMax = 0;
  pub.mastHeightWorld = 0;
  pub.mastViewboxHeight = 10;
  pub.mastSizeIndex = 0;
  pub.topLumMarginmm = 800;
  pub.bottomLumMarginmm = 3000;
  pub.topLumMarginWorld = 0;
  pub.bottomLumMarginWorld = 0;
  pub.clampPosX = 450;

  pub.mmToWorldUnit = 1;
  pub.worldUnitTomm = 1;
  pub.maxLums = 8;
  pub.minLumDistancemm = 300;
  pub.minLumDistanceWorld = 0;
  pub.minLumRotationDist = 36;
  pub.minLumRotationDistOneLevel = 72;
  pub.minLumRotationDistOneLevelShortBracketMinDistExeeded = 90;
  pub.topLumMarginmmShortBracketDegreeRotationDistanceReduced = 2000;
  pub.currentLumCount = 8;
  pub.lumType = '';
  pub.bracketType = '';

  pub.lumsOnOneLevel = false;

  pub.topLumPositionWorld = 0;
  pub.bottomLumPositionWorld = 0;
  /** this is used for candelabra only */
  pub.candelabraRotation = 0;
  pub.startRotation = 0;

  pub.advancedMode = false;

  pub.singleSelectedLum = -1;
  pub.firstAndLastLumSelected = false;
  pub.mastSelected = false;


  pub.colorMastFill = '#ffffff';
  pub.colorMastOutline = '#000000';
  pub.colorMastFillSelected = '#000000';
  pub.colorMastOutlineSelected = '#ffffff';

  pub.setAdvancedMode = function(value) {
    pub.advancedMode = value;
    if (value === true) {
      pub.lumsOnOneLevel = false;
    }
  };

  pub.isAdvancedMode = function() {
    return pub.advancedMode === true && pub.product !== OLIVIO.PRODUCT_CANDELABRA;
  };

  pub.getStartRotationMathematical = function () {
    var angle = 360-pub.startRotation;
    if (angle>=360) {
      angle-=360;
    }
    return angle;
  };

  pub.setStartRotationMathematical = function (value) {
    if (value >= 360) {
      value = 0;
    }
    var angle = (360-value) % 360;

    pub.setStartRotation(angle);
  };

  pub.setSingleLumRotationAdvancedMathematical = function (newRotation, index, probagateToAngular) {
    //TODO check for collisions: im AdvancedMode dürfen die nicht auf selbser Ebene sein, dann braucht man den Check nicht


    //FIXME wozu ist das da? bzw. das nächste if korrigiert nur newRotation = 0; was auch das übernächste if tut ?!
    if (newRotation >= 360 || newRotation < 0) {
      newRotation = 0;
    }

    newRotation= 360-newRotation;
    if (newRotation>=360) {
      newRotation-=360;
    }

    if (newRotation === 360) {
      newRotation = 0;
    }

    var lumc = lumieres[index];

    var newRotationCombined = newRotation + pub.candelabraRotation + pub.startRotation;
    pub.setLumRotationCombined(index, newRotationCombined);

    lumChangeHandler();

    if (probagateToAngular === true) {
      //console.log('angular will get a mastheight update');
      angularHandler();
    }

  };

  pub.getJointPositionWorldOfLum = function (index) {
    return lumieres[index].getJointPositionWorld();
  };

  pub.setSingleLumSelected = function (index) {
    console.log('setSingleLumSelected searching '+index);
    //pub.singleSelectedLum = -1;

    pub.firstAndLastLumSelected = false;

    // we don't need to search, as index respects the gap already
    pub.singleSelectedLum = index;
    //console.log('setSingleLumSelected: -> lumChangeHandler')
    lumChangeHandler(); // ruft u.a. die beiden updateLums auf
  };


  pub.setFirstAndLastLumSelected = function () {
    //console.log('setFirstAndLastLumSelected');
    pub.singleSelectedLum = -1;
    pub.firstAndLastLumSelected = true;
    lumChangeHandler();
  };

  pub.setSingleLumHeightBymm = function (value, index, probagateToAngular) {

    var newLumPos = pub.mastHeightWorldMax - (value * pub.mmToWorldUnit);

    var lumToChange = lumieres[index];

    // use the dragging function to set the lums position. hacky but works
    lumToChange.positionFromDraging = lumToChange.getLumPositionWorld();
    pub.setLumWorldPosition(index,(newLumPos-lumToChange.positionFromDraging)-lum.lumJointOffsetWorld);

    lumChangeHandler();
    if (probagateToAngular === true) {
      //console.log('angular will get a mastheight update');
      angularHandler();
    }
  };

  pub.mastScale = 1;
  pub.scaledMastSizesWorld = [];
  pub.scaledMastHeightWorld = 10;
  pub.scaledMastHeightWorldMax = 10;

  var startArrangingLumCount = 8;

  var startAngleSnapping = [0, 90, 180, 270];
  var endAngleSnapping = [315, 0, 90, 180, 270];

  var uniformAngleDistribution = false;

  var lumieres = [];
  var topToBottomRotationClockwise = true;
  var startRotation = 0;
  var topToBottomRotation = 360;

  // FIXME this is bad design, as it forces to have only one main, and one set of controls, but in fact we have four sets: design, charging, details and checkout where we always destroy main in the switch.
  // ie. we created a singleton which would not have the need for a called back as could be called directly -- if this had been implemetend somewhat sane
  var lumChangeHandler;               // value gets initiated be single call to removeCallbacks below
  var mastChangeHandler;              // value gets initiated be single call to removeCallbacks below
  var advancedSelectionChangeHandler; // value gets initiated be single call to removeCallbacks below
  var angularHandler;                 // value gets initiated be single call to removeCallbacks below

  pub.setCallbacks = function (lumsChanged, mastChanged) {
    lumChangeHandler = lumsChanged;
    mastChangeHandler = mastChanged;
  };
  pub.setAngularCallback = function (angularCallback) {
    console.log('v- setAngularCallback');
    angularHandler = angularCallback;
    lumChangeHandler();
    angularHandler();
    console.log('^- setAngularCallback');
  };
  pub.removeCallbacks = function () {
    lumChangeHandler = function () {
      console.log('\n >>>>>>>>>> ERROR: lumChangeHandler not set\n\n');
    };
    mastChangeHandler = function () {
      console.log('\n >>>>>>>>>> ERROR: lumChangeHandler not set\n\n');
    };
    advancedSelectionChangeHandler = function () {
      console.log('\n >>>>>>>>>> ERROR: lumChangeHandler not set\n\n');
    };
    angularHandler = function () {
      console.log('\n >>>>>>>>>> ERROR: lumChangeHandler not set\n\n');
    };
  };
  pub.removeCallbacks(); // initiate




  /**Array.<OLIVIO.LumData>*/ lumieres = [];
  for (var l = 0; l < 8; l++) {
    var lum = new OLIVIO.LumData();
    lum.modelIndex = l;
    lumieres.push(lum);
  }


  pub.initFromAngularModel = function (model, data) {
    var _logIdx = 0;
    console.log('v-- initFromAngularModel', data, model, pub, lumieres, '\n',
      _logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n'
    );
    pub.product = model.product.id;

    pub.mastSizesmm = data.getMastOption(model.product.id).mastSizesmm;
    pub.mastDiametermm = data.getMastOption(model.product.id).mastDiametermm;
    pub.mastSizeChangeable =  pub.mastSizesmm.length > 1;

    if (pub.product === OLIVIO.PRODUCT_SISTEMA) {
      pub.candelabraRotation = 0;
      pub.minLumDistancemm = 300;
      pub.mastHeightWorldMax = 3960;
      pub.mastViewboxHeight = 3960;
      pub.maxLums = 8;
      pub.mastScale = 1;
      pub.mmToWorldUnit = pub.mastHeightWorldMax / 12000;
    } else if (pub.product === OLIVIO.PRODUCT_FLORACION) {
      pub.candelabraRotation = 0;
      pub.minLumDistancemm = 600;
      pub.mastHeightWorldMax = 3960;
      pub.mastViewboxHeight = 3960;
      //pub.mastSizesmm = [12000, 10000, 9000, 8000, 7000, 5800, 4800];
      pub.maxLums = 8;
      pub.mastScale = 1;
      pub.mmToWorldUnit = pub.mastHeightWorldMax / pub.mastSizesmm[0];
    } else if (pub.product === OLIVIO.PRODUCT_CANDELABRA) {
      pub.mastHeightWorldMax = 1363.65;
      pub.mastViewboxHeight = 3960;
      //pub.mastSizesmm = [4500, 3000];
      pub.maxLums = 3;
      pub.mastScale = 3960 / 1363.65;
      pub.mmToWorldUnit = pub.mastHeightWorldMax / pub.mastSizesmm[0];
    }



    pub.startRotation = (360-model.design.startDegree) % 360;

    topToBottomRotation = model.design.topToBottomRotation;
    topToBottomRotationClockwise = model.design.topToBottomRotationCW;

    pub.worldUnitTomm = pub.mastSizesmm[0] / pub.mastHeightWorldMax;
    pub.mastHeightWorld = pub.mastSizesmm[pub.mastSizeIndex] * pub.mmToWorldUnit;
    pub.topLumMarginWorld = OLIVIO.cmodel.topLumMarginmm * OLIVIO.cmodel.mmToWorldUnit;
    pub.bottomLumMarginWorld = OLIVIO.cmodel.bottomLumMarginmm * OLIVIO.cmodel.mmToWorldUnit;

    pub.minLumDistanceWorld = pub.minLumDistancemm * pub.mmToWorldUnit;

    pub.topLumPositionWorld = lumieres[0].getJointPositionWorld();
    pub.bottomLumPositionWorld = lumieres[lumieres.length - 1].getJointPositionWorld();



    pub.scaledMastHeightWorld = pub.mastHeightWorld * pub.mastScale;
    pub.scaledMastHeightWorldMax = pub.mastHeightWorldMax * pub.mastScale;

    pub.mastSizesWorld = [];
    pub.scaledMastSizesWorld = [];

    for (var j = 0; j < pub.mastSizesmm.length; j++) {
      //console.log('OLIVIO.cmodel.mastSizesmm['+j+']: '+OLIVIO.cmodel.mastSizesmm[j]);
      pub.mastSizesWorld[j] = (pub.mastSizesmm[j] * pub.mmToWorldUnit);
      pub.scaledMastSizesWorld[j] = pub.mastSizesWorld[j] * pub.mastScale;
    }


    //OLIVIO.cmodel.mastHeightWorldMax = 3980;
    pub.lumType = model.design.lumtype;
    pub.bracketType = model.design.beamtype;
    for (var l = 0; l < 8; l++) {
      // TODO have a look if i need this for checkout
      //lumieres[l].sideLumReload = true;
      lumieres[l].lumType = model.design.lumtype;
      lumieres[l].product = pub.product;
      lumieres[l].bracketType = model.design.beamtype;
      lumieres[l].updateFromTypeChange();
    }

    pub.setColors(
      data.getColorSelectOption(model.design.colorIds.mast).color,
      data.getColorSelectOption(model.design.colorIds.lumiere).color,
      data.getColorSelectOption(model.design.colorIds.inlay).color,
      data.getColorSelectOption(model.design.colorIds.mast).colorOutline,
      data.getColorSelectOption(model.design.colorIds.lumiere).colorOutline,
      data.getColorSelectOption(model.design.colorIds.inlay).colorOutline
    );


    var mindex = pub.mastSizesmm.indexOf(model.design.height);
    pub.setMastHeightByIndex((mindex >= 0 ? mindex : 0));

    pub.currentLumCount = model.design.lumcount > pub.maxLums ? pub.maxLums : model.design.lumcount;

    pub.topLumPositionWorld = pub.mastHeightWorldMax - (model.design.toplumiereheight * pub.mmToWorldUnit);
    pub.bottomLumPositionWorld = pub.mastHeightWorldMax - (model.design.bottomlumiereheight * pub.mmToWorldUnit);
    pub.updateLumBoundariesWorld();

    updateVisibility(1);
    var visLums = getVisibleLums();

    for (var v = 0; v < visLums.length; v++) {
      var lum = visLums[v];
      //lum.setRotationWithStartMathematical(model.design.individualRotations[v]); FIXME remove this line
      lum.lumRotationCombined = model.design.individualRotations[v];

      var lumPos = pub.mastHeightWorldMax - (model.design.individualHeights[v] * pub.mmToWorldUnit);
      lum.lumType = model.design.individualHeads[v];
      lum.updateFromTypeChange();
      lum.setJointPositionWorld(lumPos);
      console.log('+-- initFromAngularModel lum '+v+':', lumPos +' mm',  model.design.individualRotations[v]+'° => ' + lum.lumRotationCombined + '°')
    }
    updateOneLevelState();
    checkSistema3Bracket();

    console.log('^-- initFromAngularModel', data, model, pub, pub.currentLumCount, '\n',
      _logIdx = 0, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n',
      ++_logIdx, lumieres[_logIdx].lumRotationCombined, lumieres[_logIdx].lumVisible, '\n'
    );
  };

  pub.getMastViewBoxOffset = function() {
    var height = pub.mastHeightWorld;
    var y = pub.mastHeightWorldMax-height;
    return {y:y, height:height};

  };

  pub.updateModelWithIndividualValues = function(model) {
    //console.log('v before updateModelWithIndividualValues: '+model.design.individualHeads);
    var visLums = getVisibleLums();
    model.design.individualRotations = [];
    model.design.individualHeights = [];
    model.design.individualHeads = [];
    var mIndex = 0;
    for (var v = 0; v < visLums.length; v++) {
      var lum = visLums[v];
      if (lum.lumVisible === true) { //  FIXME this code already works only on visible lums
        //model.design.individualRotations.push(Math.round(lum.getRotationWithStartMathematical())); FIXME remove this line
        model.design.individualRotations.push(Math.round(lum.lumRotationCombined));

        model.design.individualHeights.push(Math.round((pub.mastHeightWorldMax - lum.getJointPositionWorld()) * pub.worldUnitTomm));
        model.design.individualHeads.push(lum.lumType);
        //console.log('+ updateModelWithIndividualValues '+v+'*:', lum.lumType, Math.round((pub.mastHeightWorldMax - lum.getJointPositionWorld()) * pub.worldUnitTomm)+'mm', Math.round(lum.getRotationWithStartMathematical())+'°');
        mIndex++;
      }
    }
    //console.log('^ after updateModelWithIndividualValues: '+model.design.individualHeads);
  };

  pub.setColors = function (mastColor, lumColor, inlayColor, mastColorOutline, lumColorOutline, inlayColorOutline) {
    //console.log('setColors: '+mastColor  +" "+ lumColor+" "+ inlayColor+" "+ mastColorOutline+" "+ lumColorOutline+" "+ inlayColorOutline);
    if (pub.product === OLIVIO.PRODUCT_SISTEMA) {
      lumColor = mastColor;
      lumColorOutline = mastColorOutline;
    }
    pub.colorMastFill = mastColor;
    pub.colorMastOutline = mastColorOutline;
    for (var l = 0; l < 8; l++) {
      if (lumieres[l].colorFill !== lumColor) {
        lumieres[l].colorFill = lumColor;
        lumieres[l].sideLumReload = true;
      }
      if (lumieres[l].colorOutline !== lumColorOutline) {
        lumieres[l].colorOutline = lumColorOutline;
        lumieres[l].sideLumReload = true;
      }
      if (lumieres[l].colorFillInlay !== inlayColor) {
        lumieres[l].colorFillInlay = inlayColor;
        lumieres[l].sideLumReload = true;
      }
      if (lumieres[l].colorOutlineInlay !== inlayColorOutline) {
        lumieres[l].colorOutlineInlay = inlayColorOutline;
        lumieres[l].sideLumReload = true;
      }
    }

    lumChangeHandler();
    mastChangeHandler();
  };

  pub.setLumTypes = function (lumTypes, gobos) {
    console.log('setLumTypes', lumTypes, gobos);
    // FIXME: analog zum Zeichnen-Code bei n Gobos zuerst lumTypes[length-1] = gobos[n-1] ? OLIVIO.LUM_GRANDE : lumTypes[n-1];, dann von für n-1 sichtbare per Zähler wie bisher
    var visLums = getVisibleLums();
    for (var v = 0; v < visLums.length; v++) {
      var lum = visLums[v];
      if (lum.lumVisible === true) {
        lum.lumType = gobos[v] ? OLIVIO.LUM_GRANDE : lumTypes[v];
        lum.updateFromTypeChange();
        lum.sideLumReload = true;
      }
    }
    //TODO check if this works
    if (!pub.isAdvancedMode()) {
      updateLumPositions();
    }

    lumChangeHandler();
  };

  pub.setBracketType = function (type) {
    pub.bracketType = type;
    checkSistema3Bracket();
    for (var l = 0; l < 8; l++) {
      lumieres[l].bracketType = type;
      lumieres[l].updateFromTypeChange();
      lumieres[l].sideLumReload = true;
    }
    // TODO check if this works, too xD
    if(!pub.isAdvancedMode()) {
      updateLumPositions();
    }

    lumChangeHandler();
  };

  var checkSistema3Bracket = function () {
    if (pub.lumsOnOneLevel === true && pub.bracketType === OLIVIO.BRACKET_SISTEMA3) {
      pub.arrangeLumPositions (pub.bottomLumPositionWorld , pub.topLumPositionWorld , 1);
    }
  };

  pub.updateLumBoundariesWorld = function () {
    pub.bottomLumBoundaryWorld = OLIVIO.cmodel.mastHeightWorldMax - OLIVIO.cmodel.bottomLumMarginWorld;
    pub.topLumBoundaryWorld = OLIVIO.cmodel.mastHeightWorldMax - OLIVIO.cmodel.mastHeightWorld + OLIVIO.cmodel.topLumMarginWorld;
  };

  pub.getTopToBottomRotation = function () {
    return Math.round(topToBottomRotation);
  };

  pub.getTopToBottomRotationCW = function () {
    return topToBottomRotationClockwise;
  };


  pub.setTopLumHeightBymm = function (value) {
    var newTopLumPos = pub.mastHeightWorldMax - (value * pub.mmToWorldUnit);

    if (newTopLumPos < pub.topLumBoundaryWorld) {
      newTopLumPos = pub.topLumBoundaryWorld;
    } else if (newTopLumPos > pub.bottomLumPositionWorld) {
      newTopLumPos = pub.bottomLumPositionWorld;
    }

    pub.topLumPositionWorld = newTopLumPos;
    updateOneLevelState();
    if (pub.lumsOnOneLevel === true) {
      pub.currentLumCount = pub.getMaxPossibleLums();
    } else {
      pub.currentLumCount = Math.min(pub.currentLumCount, pub.getMaxPossibleLums());
    }
    updateVisibility(1);
    updateLumPositions();
    updateLumRotations();
    lumChangeHandler();
    angularHandler();
  };

  pub.setBottomLumHeightBymm = function (value) {
    var newBottomLumPos = pub.mastHeightWorldMax - (value * pub.mmToWorldUnit);

    if (newBottomLumPos > pub.bottomLumBoundaryWorld) {
      newBottomLumPos = pub.bottomLumBoundaryWorld; // ie. NOP, see first line after if-else
    } else if (newBottomLumPos < pub.topLumPositionWorld) {
      newBottomLumPos = pub.topLumPositionWorld;
    }

    pub.bottomLumPositionWorld = newBottomLumPos;

    updateOneLevelState();
    if (pub.lumsOnOneLevel === true) {
      pub.currentLumCount = pub.getMaxPossibleLums();
    } else {
      pub.currentLumCount = Math.min(pub.currentLumCount, pub.getMaxPossibleLums());
    }
    updateVisibility(1);
    updateLumPositions();
    updateLumRotations();
    lumChangeHandler();
    angularHandler();
  };

  var getVisibleLums = function () {
    var vislums = [];
    for (var i = 0; i < lumieres.length; i++) {
      if (lumieres[i].lumVisible === true) {
        vislums.push(lumieres[i]);
      }
    }
    return vislums;
  };

  pub.getLumieres = function () {
    return lumieres;
  };

  var getGroupedLums = function (groupId) {

    var groupedLums = [];
    if (groupId === -1) {
      return groupedLums;
    }
    for (var i = 0; i < lumieres.length; i++) {
      if (lumieres[i].groupId === groupId) {
        groupedLums.push(lumieres[i]);
      }
    }
    return groupedLums;
  };

  pub.updateLumBoundariesAdvanced = function () {

    for (var gi = 0; gi < lumieres.length; gi++) {
      lumieres[gi].groupId = -1;
      lumieres[gi].positionSnapToGroupTop = -1;
      lumieres[gi].positionSnapToGroupBottom = -1;
      lumieres[gi].rotationGroupCombinedRotations = [];
    }

    var groupId = 0;
    var loopIsInGroup = false;

    var vislums = getVisibleLums();
    //var lumsDist = getCurrentRotationDistance();

    var prevLum;
    var nextLum;
    var lum;

    for (var i = 0; i < vislums.length; i++) {
      lum = vislums[i];
      lum.positionFromDraging = lum.getLumPositionWorld();
      if (i===0) {
        prevLum = vislums[vislums.length-1];
        lum.positionBoundaryTopWorld = pub.topLumBoundaryWorld-lum.lumJointOffsetWorld;
      } else {
        prevLum = vislums[i-1];
        lum.positionBoundaryTopWorld = prevLum.getLumPositionWorld() + pub.minLumDistanceWorld;
      }
      if (i===(vislums.length-1)) {
        nextLum = vislums[0];
        lum.positionBoundaryBottomWorld = pub.bottomLumBoundaryWorld-lum.lumJointOffsetWorld;
      } else {
        nextLum = vislums[i+1];
        lum.positionBoundaryBottomWorld = nextLum.getLumPositionWorld() - pub.minLumDistanceWorld;
      }

      /*
       if (topToBottomRotationClockwise === true) {
       lum.rotationBoundaryNext = nextLum.lumRotationCombined-lumsDist;
       lum.rotationBoundaryPrev = prevLum.lumRotationCombined+lumsDist;
       } else {
       lum.rotationBoundaryNext = prevLum.lumRotationCombined-lumsDist;
       lum.rotationBoundaryPrev = nextLum.lumRotationCombined+lumsDist;
       }

       lum.rotationBetweenBoundaries = OLIVIO.getAngleBetweenAngles(lum.rotationBoundaryPrev,lum.rotationBoundaryNext);
       */

      // finding groups

      if (i>0) {
        if (lum.getLumPositionWorld() === prevLum.getLumPositionWorld()) {
          loopIsInGroup = true;
          prevLum.groupId = groupId;
          lum.groupId = groupId;
        } else {
          if (loopIsInGroup) {
            loopIsInGroup = false;
            groupId++;
          }
        }
      }

    }
    // compute boundaries
    for (var ib = 0; ib < vislums.length; ib++) {
      lum = vislums[ib];
      if (ib===0) {
        prevLum = vislums[vislums.length-1];
      } else {
        prevLum = vislums[ib-1];
      }
      if (ib===(vislums.length-1)) {
        nextLum = vislums[0];
      } else {
        nextLum = vislums[ib+1];
      }


      // setrotationboundaries if on one level

      if (lum.groupId !== -1) {
        var rotationGrp = getGroupedLums(lum.groupId);

        for (var rbi = 0; rbi < rotationGrp.length; rbi++) {
          if (lum !== rotationGrp[rbi]) {
            lum.rotationGroupCombinedRotations.push(rotationGrp[rbi].lumRotationCombined);
            lum.rotationGroupMinDist = getRotationDistanceForWorldPos(lum.getJointPositionWorld(), true);
          }
        }

      } else {
        lum.rotationBoundaryClockWise = -1;
        lum.rotationBoundaryCounterClockWise = -1;
      }

      // groupsnapping

      if (ib>0) {
        // topsnapping
        var topRotDist = getRotationDistanceForWorldPos(prevLum.getJointPositionWorld(), true);
        var topCollision = false;
        var topGroup = getGroupedLums(prevLum.groupId);
        if (topGroup.length < 1) {
          topGroup.push(prevLum);
        }
        for (var tsi = 0; tsi < topGroup.length; tsi++) {
          var ang = Math.abs(OLIVIO.getDifferenceBetweenAngles(lum.lumRotationCombined,topGroup[tsi].lumRotationCombined));
          if (lum.modelIndex !== topGroup[tsi].modelIndex && ang < topRotDist) {
            topCollision = true;
            break;
          }
        }
        if (topCollision === false) {
          lum.positionSnapToGroupTop = prevLum.getLumPositionWorld();
        }
      }

      if (ib < vislums.length-1) {
        // bottomsnapping
        var bottomRotDist = getRotationDistanceForWorldPos(nextLum.getJointPositionWorld(), true);
        var bottomCollision = false;
        var bottomGroup = getGroupedLums(nextLum.groupId);
        if (bottomGroup.length < 1) {
          bottomGroup.push(nextLum);
        }
        for (var bsi = 0; bsi < bottomGroup.length; bsi++) {
          var angl = Math.abs(OLIVIO.getDifferenceBetweenAngles(lum.lumRotationCombined,bottomGroup[bsi].lumRotationCombined));
          if (lum.modelIndex !== bottomGroup[bsi].modelIndex && angl < bottomRotDist) {
            bottomCollision = true;
            break;
          }
        }
        if (bottomCollision === false) {
          lum.positionSnapToGroupBottom = nextLum.getLumPositionWorld();
        }
      }

    }

  };


  pub.setLumWorldPosition= function (index,delta) {
    //console.log("dragging lum: "+index+"delta: "+delta);
    var lum = lumieres[index];
    var value = lum.positionFromDraging + delta;
    lum.positionFromDraging = value;
    var lumvalue = 0;
    if (lum.positionFromDraging  < lum.positionBoundaryTopWorld) {
      lumvalue = lum.positionBoundaryTopWorld;
      if (lum.positionSnapToGroupTop !== -1 && lum.positionFromDraging  < (lum.positionBoundaryTopWorld - pub.minLumDistanceWorld*0.5) && pub.product === OLIVIO.PRODUCT_SISTEMA) {
        lumvalue = lum.positionSnapToGroupTop;
      }
    } else if (lum.positionFromDraging  > lum.positionBoundaryBottomWorld) {
      lumvalue = lum.positionBoundaryBottomWorld;
      if (lum.positionSnapToGroupBottom !== -1 && lum.positionFromDraging  > (lum.positionBoundaryBottomWorld + pub.minLumDistanceWorld*0.5) && pub.product === OLIVIO.PRODUCT_SISTEMA) {
        lumvalue = lum.positionSnapToGroupBottom;
      }
    } else {
      lumvalue = lum.positionFromDraging;
    }
    lum.setLumPositionWorld(lumvalue);
    if (index === 0) {
      pub.topLumPositionWorld = lumvalue+lum.lumJointOffsetWorld;
    } else if (index === 7) {
      if (pub.currentLumCount === 1) {
        pub.topLumPositionWorld = lumvalue+lum.lumJointOffsetWorld;
      } else {
        pub.bottomLumPositionWorld = lumvalue+lum.lumJointOffsetWorld;
      }
    }
    lumChangeHandler();
    angularHandler();
  };

  pub.setLumRotationsCombined = function (delta) {
    for (var i = 0; i < lumieres.length; i++) {
      var value = lumieres[i].lumRotationCombined+delta;
      setLumRotationCombinedNoChecks(i,value);
    }
    lumChangeHandler();
    angularHandler();
  };

  var setLumRotationCombinedNoChecks = function (index,value) {
    var lum = lumieres[index];
    while (value >= 360) {
      value -= 360;
    }
    while (value < 0) {
      value += 360;
    }

    // TODO set other rotation values correctly sometime when it's needed
    lum.lumRotationCombined = value;

    lum.sideLumReload = true;

  };

  pub.setLumRotationCombined = function (index,value) {
    var lum = lumieres[index];
    while (value >= 360) {
      value -= 360;
    }
    while (value < 0) {
      value += 360;
    }

    if (lum.groupId !== -1) {

      var difference = 666;
      var nearestRotationIndex = -1;
      var groupRotation = 0;
      var newDifference = 666;

      for (var rgi = 0; rgi < lum.rotationGroupCombinedRotations.length; rgi++) {
        groupRotation = lum.rotationGroupCombinedRotations[rgi];
        newDifference = OLIVIO.getDifferenceBetweenAngles(value,groupRotation);
        if (Math.abs(newDifference) < Math.abs(difference)) {
          difference = newDifference;
          nearestRotationIndex = rgi;
        }
      }
      if (Math.abs(difference) > lum.rotationGroupMinDist) {
        //console.log("COOL WITH: "+lum.rotationGroupCombinedRotations);
      } else {
        //get last cool rotation that the model is down with
        newDifference = 666;
        difference = 666;
        for (var lrgi = 0; lrgi < lum.rotationGroupCombinedRotations.length; lrgi++) {
          groupRotation = lum.rotationGroupCombinedRotations[lrgi];
          newDifference = OLIVIO.getDifferenceBetweenAngles(lum.lumRotationCombined,groupRotation);
          if (Math.abs(newDifference) < Math.abs(difference)) {
            difference = newDifference;
            value = lum.rotationGroupCombinedRotations[lrgi] + ((difference > 0) ? lum.rotationGroupMinDist : -lum.rotationGroupMinDist);
          }
        }
      }

    }



    //console.log('value: '+value+' next: '+lum.rotationBoundaryNext+' prev: '+lum.rotationBoundaryPrev+' next+180: '+(lum.rotationBoundaryNext+180)+' prev-180: '+(lum.rotationBoundaryPrev-180));
    /*if (index === 0) {
     pub.startRotation = value;
     if (pub.currentLumCount > 1) {
     topToBottomRotation = getTopToBottomRotationFromEndRotation(lumieres[7].lumRotationCombined);
     }
     } else if (index === 7) {
     if (pub.currentLumCount === 1) {
     pub.startRotation = value;
     } else {
     var rotation = value - pub.startRotation;
     if (rotation < 0) {
     rotation += 360;
     }
     if (topToBottomRotationClockwise === false) {
     rotation = 360 - rotation;
     }
     topToBottomRotation = rotation;
     }
     }*/

    // TODO set other rotation values correctly sometime when it's needed
    lum.lumRotationCombined = value;

    lum.sideLumReload = true;

    lumChangeHandler();
    angularHandler();

  };

  pub.setStartRotation = function (value, snap) {
    //console.log('setStartRotation', value);
    value = value % 360;
    while (value < 0) {
      value += 360;
    }

    if (snap === true) {
      var testValue = value > 355 ? 0 : value;
      for (var i = 0; i < startAngleSnapping.length; i++) {
        if (testValue < (startAngleSnapping[i] + 5) && testValue > (startAngleSnapping[i] - 5)) {
          value = startAngleSnapping[i];
          break;
        }
      }
    }

    if (value !== pub.startRotation) {
      pub.startRotation = value;

      updateLumRotations();


      lumChangeHandler();
      angularHandler();

    }
  };

  pub.setCandelabraRotation = function (value) {
    value = value % 360;
    while (value < 0) {
      value += 360;
    }

    if (value !== pub.candelabraRotation) {
      pub.candelabraRotation = value;
      lumChangeHandler();
    }

  };

  pub.getLumWorldPosbyPosFrombottommm = function (value) {
    return  pub.mastHeightWorldMax - (value * pub.mmToWorldUnit);
  };
  /*
   pub.getLumFromBottommmPosbyWorldPos = function (value) {
   return  (pub.mastHeightWorldMax-value) * pub.worldUnitTomm;
   };
   */
  var getPossibleLumsForBoundarymm = function (boundarymm) {
    var possibleLums = 1;
    for (var l = 0; l < pub.maxLums; l++) {
      //console.log(boundarymm+' '+(boundarymm/l));
      if (boundarymm / l >= pub.minLumDistancemm) {
        possibleLums = l + 1;
      }
    }
    return possibleLums;
  };

  var updateLumPositions = function () {

    var boundaryWorld = pub.bottomLumPositionWorld - pub.topLumPositionWorld;

    var stepSize = 0;
    if (pub.currentLumCount > 1) {
      stepSize = boundaryWorld / (pub.currentLumCount - 1);
    }

    var c3 = 0;
    for (var j = 0; j < lumieres.length; j++) {
      var lumc = lumieres[j];
      if (pub.lumsOnOneLevel === true) {
        lumc.setLumPositionWorld((pub.topLumPositionWorld - lumc.lumJointOffsetWorld));
      } else {
        lumc.setLumPositionWorld((pub.topLumPositionWorld - lumc.lumJointOffsetWorld) + (stepSize * c3));
      }

      if (lumc.lumVisible) {
        //lumc.lumPositionWorld = (pub.topLumPositionWorld - lumc.lumJointOffsetWorld) + (stepSize*c3);
        c3++;
      }
    }
  };

  pub.startArrangingLumPositions = function () {
    console.log('startArrangingLumPositions: '+pub.currentLumCount);
    startArrangingLumCount = pub.currentLumCount;
    endAngleSnapping[0] = 360 - (360 / startArrangingLumCount);
  };

  pub.getStartLumCount = function () {
    //console.log(startArrangingLumCount);
    return  startArrangingLumCount;
  };

  pub.rearrangeLumsForBasicMode = function() {
    console.log('vvv---rearrangeLumsForBasicMode',pub.currentLumCount);
    pub.arrangeLumPositions(pub.topLumPositionWorld, pub.bottomLumPositionWorld, 1);
    console.log('^^^---rearrangeLumsForBasicMode',pub.currentLumCount);
  };

  pub.arrangeLumPositions = function (topJointWorld, bottomJointWorld, arrangingReason) {
    //console.log(startArrangingLumCount);
    pub.bottomLumPositionWorld = bottomJointWorld;
    pub.topLumPositionWorld = topJointWorld;
    updateOneLevelState();
    console.log('arrangeLumPositions', pub.lumsOnOneLevel, pub.currentLumCount, startArrangingLumCount, pub.getMaxPossibleLums());

    if (pub.lumsOnOneLevel === true) {
      //pub.currentLumCount = pub.getMaxPossibleLums(); // DONE, siehe updateOneLevelState(): das sollte nur passieren, wenn lumsOnOneLevel auf true gesetzt wird
    } else {
      pub.currentLumCount = Math.min(startArrangingLumCount, pub.getMaxPossibleLums()); // FIXME die Anzahl sollte sich in "arrange" nicht ändern. richtigen Ort suchen, falls überhaupt notwendig?
    }

    // arrangingreason 1 means loosing lumieres from bottom up
    updateVisibility(arrangingReason);
    updateLumPositions();
    updateLumRotations();
    lumChangeHandler();
    angularHandler();
  };

  pub.updateAll = function () {
    updateVisibility(1);
    updateLumPositions();
    updateLumRotations();
    lumChangeHandler();
    angularHandler();
  };


  var getCurrentRotationDistance = function() {
    var lumsDist = pub.minLumRotationDist;
    //console.log('check possiblelums');
    if (pub.lumsOnOneLevel === true) {

      lumsDist = pub.minLumRotationDistOneLevel;
      if (pub.product === OLIVIO.PRODUCT_FLORACION) {
        lumsDist = 360;
      } else if (pub.bracketType === OLIVIO.BRACKET_SISTEMA3 && pub.mastSizesmm[pub.mastSizeIndex]-pub.getTopLumPosmm() < pub.topLumMarginmmShortBracketDegreeRotationDistanceReduced) {
        lumsDist = pub.minLumRotationDistOneLevelShortBracketMinDistExeeded;
      }
    }
    return lumsDist;
  };

  var getRotationDistanceForWorldPos = function(worldPos, multiLums) {
    var lumsDist = pub.minLumRotationDist;
    //console.log('check possiblelums');

    if (multiLums === true) {

      lumsDist = pub.minLumRotationDistOneLevel;
      if (pub.product === OLIVIO.PRODUCT_FLORACION) {
        lumsDist = 360;
      } else if (pub.bracketType === OLIVIO.BRACKET_SISTEMA3 && pub.mastSizesmm[pub.mastSizeIndex]-getPosmmRoundedFromWorld(worldPos) < pub.topLumMarginmmShortBracketDegreeRotationDistanceReduced) {
        lumsDist = pub.minLumRotationDistOneLevelShortBracketMinDistExeeded;
      }
    }
    return lumsDist;
  };



  var getPossibleLumsForRotation = function (rotation) {
    var possibleLums = 1;
    var lumsDist = getCurrentRotationDistance();

    for (var l = 0; l < pub.maxLums; l++) {
      if (rotation / l >= lumsDist) {
        // console.log(rotation/l);
        possibleLums = l + 1;
      }
    }
    if (pub.lumsOnOneLevel === true) {
      if (rotation >= 360) {
        possibleLums--;
      }
      if (rotation > (360 - lumsDist)) {
        //console.log('CHANGE ROTATION BECAUSE!!!');
        //pub.arrangeLumRotations();
        //possibleLums--;
        topToBottomRotation = lumsDist*(possibleLums-1);
        pub.currentLumCount = possibleLums;
        updateVisibility(1);
        //updateLumRotations();
      }
    }
    //console.log(pub.minLumRotationDistOneLevel+'  '+possibleLums);
    return possibleLums;
  };

  /* *equaly distribute lums. to be called only if NOT in advanced editing mode */
  var updateLumRotations = function () {
    var stepSize = 0;

    if(pub.currentLumCount>1) {
      // ?: treat first lum also as last lum when doing a full 360: place last one just below the first one
      stepSize = topToBottomRotation / (pub.currentLumCount - (topToBottomRotation === 360 ? 0 : 1));
    }
    console.log('updateLumRotations','topToBottomRotation: '+topToBottomRotation,'stepSize: '+stepSize, pub.candelabraRotation, pub.startRotation);

    var vc = 0;
    var direction = topToBottomRotationClockwise ? 1 : -1;
    //console.log('>>>>lumrotations<<<<');
    for (var i = 0; i < lumieres.length; i++) {
      var lumc = lumieres[i];
      if (lumc.lumVisible) {

        var newRotation = (stepSize * vc * direction + 360) % 360; // +360 necesarry if direction==-1

        var newRotationCombined = (newRotation + pub.startRotation) % 360;

        lumc.sideLumReload = (newRotationCombined !== lumc.lumRotationCombined);
        lumc.lumRotationCombined = newRotationCombined;

        //console.log(i+'. visible: '+vc+' reload: '+lumc.sideLumReload, lumc.lumRotation, lumc.lumRotationCombined, 'stepSize: '+stepSize, direction, (stepSize * vc * direction + 360), (stepSize * vc * direction + 360) % 360);
        vc++;
      }
    }
  };

  pub.setTopToBottomRotationClockwise = function (value) {
    topToBottomRotationClockwise = value;
    updateLumRotations();
    lumChangeHandler();
    angularHandler();
  };

  var getTopToBottomRotationFromEndRotation = function (endrotation) {
    var rotation = endrotation - pub.startRotation;
    if (rotation < 0) {
      rotation += 360;
    }
    if (topToBottomRotationClockwise === false) {
      rotation = 360 - rotation;
    }
    return rotation;
  };

  pub.setEndRotation = function (endrotation) {
    //console.log('startRotation: '+pub.startRotation + 'endRotation: '+endrotation);
    var rotation = getTopToBottomRotationFromEndRotation(endrotation);

    uniformAngleDistribution = false;

    var testValue = rotation > 355 ? 0 : rotation;
    for (var i = 0; i < endAngleSnapping.length; i++) {
      if (testValue < (endAngleSnapping[i] + 5) && testValue > (endAngleSnapping[i] - 5)) {
        rotation = endAngleSnapping[i];
        uniformAngleDistribution = (i === 0);
        break;
      }
    }

    pub.arrangeLumRotations(rotation);
  };

  pub.arrangeLumRotations = function (rotation) {

    if (pub.product === OLIVIO.PRODUCT_CANDELABRA) {
      topToBottomRotation = rotation;
      lumChangeHandler();
      return;
    }
    //console.log(rotation);
    if (rotation >= 360) {
      rotation = 360 - (360 / pub.currentLumCount);
    } else if (rotation > 360 - (pub.lumsOnOneLevel === true ? pub.minLumRotationDistOneLevel : pub.minLumRotationDist)) {
      rotation = 360 - (pub.lumsOnOneLevel === true ? pub.minLumRotationDistOneLevel : pub.minLumRotationDist);
    }

    topToBottomRotation = rotation;
    uniformAngleDistribution = (360 - (360 / pub.currentLumCount)) === topToBottomRotation;
    pub.currentLumCount = Math.min(startArrangingLumCount, pub.getMaxPossibleLums());
    //pub.currentLumCount = Math.min(pub.currentLumCount, pub.getMaxPossibleLums());
    //console.log('arrangeLumRotations pub.currentLumCount :'+pub.currentLumCount);
    // arrangingreason 1 means loosing lumieres from bottom up
    updateVisibility(1);
    updateLumRotations();
    updateLumPositions();
    lumChangeHandler();
    angularHandler();
  };

  pub.getTopLumPosmm = function () {
    return getPosmmRoundedFromWorld(pub.topLumPositionWorld);
  };

  pub.getBottomLumPosmm = function () {
    return getPosmmRoundedFromWorld(pub.bottomLumPositionWorld);
  };

  var getPosmmRoundedFromWorld = function (worldPos) {
    return ((pub.mastHeightWorldMax - worldPos) * pub.worldUnitTomm);
  };

  pub.setMastHeightByIndex = function (index, probagateToAngular) {
    var newHeight = pub.mastSizesWorld[index];
    console.log('cmodel.setMastHeightByIndex '+index+': '+newHeight+(probagateToAngular?' ->angular':''));
    if (newHeight !== pub.mastHeightWorld) {

      if (pub.isAdvancedMode()) {

        pub.mastHeightWorld = newHeight;
        pub.scaledMastHeightWorld = pub.mastHeightWorld * pub.mastScale;
        pub.mastSizeIndex = index;
        pub.topLumPositionWorld = pub.mastHeightWorldMax + (pub.topLumMarginmm * pub.mmToWorldUnit) - newHeight;
        pub.bottomLumPositionWorld = pub.mastHeightWorldMax - (pub.bottomLumMarginmm * pub.mmToWorldUnit);

        //pub.bottomLumBoundaryWorld = OLIVIO.cmodel.mastHeightWorldMax - OLIVIO.cmodel.bottomLumMarginWorld;
        //pub.topLumBoundaryWorld = OLIVIO.cmodel.mastHeightWorldMax - OLIVIO.cmodel.mastHeightWorld + OLIVIO.cmodel.topLumMarginWorld;

        pub.updateLumBoundariesWorld();
        if (pub.product !== OLIVIO.PRODUCT_CANDELABRA) {
          pub.currentLumCount = pub.getMaxPossibleLums();
          pub.bottomLumPositionWorld = pub.topLumPositionWorld + ((pub.minLumDistancemm*pub.mmToWorldUnit)*(pub.currentLumCount-1))+10;
        }
        updateVisibility(1);
        updateLumPositions();
        updateLumRotations();
        updateVisibility(1);

        var c3 = 0;
        for (var j = 0; j < lumieres.length; j++) {
          var lumc = lumieres[j];
          if (lumc.lumVisible) {
            lumc.setLumPositionWorld((pub.topLumPositionWorld - lumc.lumJointOffsetWorld) + ((pub.minLumDistancemm*pub.mmToWorldUnit) * c3));
            c3++;
          }
        }

        pub.updateLumBoundariesAdvanced();
        updateModelIndex();
        lumChangeHandler();
      } else {
        if (pub.topLumPositionWorld < pub.mastHeightWorldMax + (pub.topLumMarginmm * pub.mmToWorldUnit) - newHeight) {
          //
          var newTopPos = pub.mastHeightWorldMax + (pub.topLumMarginmm * pub.mmToWorldUnit) - newHeight;
          var newBottomPos = newTopPos + (pub.bottomLumPositionWorld - pub.topLumPositionWorld);
          //console.log('newBottomPos: '+newBottomPos);
          //console.log(pub.mastHeightWorldMax - (pub.bottomLumMarginmm * pub.mmToWorldUnit));
          if (newBottomPos > pub.mastHeightWorldMax - (pub.bottomLumMarginmm * pub.mmToWorldUnit)) {
            newBottomPos = pub.mastHeightWorldMax - (pub.bottomLumMarginmm * pub.mmToWorldUnit);
          }
          pub.topLumPositionWorld = newTopPos;
          pub.bottomLumPositionWorld = newBottomPos;
          //console.log('pub.bottomLumPositionWorld '+pub.bottomLumPositionWorld);
          if (pub.product !== OLIVIO.PRODUCT_CANDELABRA) {
            pub.currentLumCount = pub.getMaxPossibleLums();
          }

        }

        pub.updateLumBoundariesWorld();
        updateVisibility(1);
        updateVisibility(1);
        updateLumPositions();
        updateLumRotations();
        lumChangeHandler();
      }

    }
    pub.mastHeightWorld = newHeight;
    pub.scaledMastHeightWorld = pub.mastHeightWorld * pub.mastScale;
    pub.mastSizeIndex = index;
    pub.updateLumBoundariesWorld();

    mastChangeHandler();

    if (typeof probagateToAngular !== 'undefined' && probagateToAngular === true && angularHandler !== null) {
      //console.log('angular will get a mastheight update');
      angularHandler();
    }
  };



  ///////////////////////////////



  pub.setLumCount = function (count) {
    var oldLumCount = pub.currentLumCount;
    var lessLums = count < pub.currentLumCount;
    console.log('v-------- setLumCont '+pub.currentLumCount+ ' => ' + count+' lessLums: '+lessLums);
    var maxLums = 8;
    if (pub.isAdvancedMode()) {
      maxLums = 8;
    } else {
      maxLums = pub.getMaxPossibleLums();
    }

    if (count <= maxLums && count > 0) {
      pub.currentLumCount = count;
    }
    if (pub.lumsOnOneLevel === true && pub.product === OLIVIO.PRODUCT_FLORACION && count > 1) {
      pub.currentLumCount = 1;
      console.log('+-------- setLumCont A '+count + ': '+oldLumCount + ' => ' + pub.currentLumCount);
      angularHandler();
      return;
    }

    if (!pub.isAdvancedMode()) {
      console.log('+-------- setLumCont _not_ isAdvancedMode(), setting topToBottomRotation', uniformAngleDistribution);
      // FIXME this should be simplified and converted to a function without storing the result
      if (uniformAngleDistribution === true && pub.product !== OLIVIO.PRODUCT_CANDELABRA && count > 1) {
        topToBottomRotation = 360 - (360 / pub.currentLumCount);
      }

      if (topToBottomRotation < pub.minLumRotationDist && count === 2) {
        topToBottomRotation = 180;
        pub.currentLumCount = 2;
      }
    }
    // FIXME this if should be integrated in the one above
    if (pub.product === OLIVIO.PRODUCT_CANDELABRA) {
      console.log('+-------- setLumCount CANDLABRA');
      if (count === 3) {
        //topToBottomRotation = 240;
      } else if (count === 2) {
        if (topToBottomRotation !== 120) {
          topToBottomRotation = 180;
        }
      } else {
        //topToBottomRotation = 0;
      }

    }

    // console.log(pub.currentLumCount);
    // arrangingreason 1 means loosing lumieres from bottom up


    if (pub.isAdvancedMode()) {
      console.log('+-------- setLumCount isAdvancedMode, lessLums: '+lessLums, 'delta: '+ (pub.currentLumCount - oldLumCount) );
      // advanced arranging

      if (lessLums === true) {
        var toRemove = oldLumCount - pub.currentLumCount;

        //   dieser Code schiebt die 2. höchste nach dem Löschen noch sichtbare Lum auf den höchsten index
        //   damit ist die am höchsten index gelöscht, die dazwischen werden einfach nur unsichtbar gemacht
        for(var i = lumieres.length - 2; toRemove > 0 && i>=0; i-- ) {
          if(lumieres[i].lumVisible) {
            console.log('+-------- setLumCount '+(toRemove>1?'re':'')+'moving lumiere '+i);
            toRemove--;
            lumieres[i].lumVisible = false;
            if(toRemove === 0) {
              // this is the last turn to remove. as we kept [lumieres.length - 1] above we now have to overwrite it with the data from here
              lumieres[lumieres.length-1].lumType = lumieres[i].lumType;
              lumieres[lumieres.length-1].updateFromTypeChange();
              lumieres[lumieres.length-1].setJointPositionWorld(lumieres[i].getJointPositionWorld());
              lumieres[lumieres.length-1].lumRotationCombined = lumieres[i].lumRotationCombined;
              lumieres[lumieres.length-1].sideLumReload = true;
            }
          }
        }
        if(toRemove > 0) {
          console.log('\n+-------- setLumCount ERROR: not enough visible lums to remove, ' + toRemove + 'missing!\n');
        }

      } else {
        var toAdd = pub.currentLumCount - oldLumCount;

        // FIXME per Division feststellen, wieviel neue Lums passen. zuerst prüfen wieviele unterhalb passen, dann oberhalb, dann zwischenräume füllen, abschließend pub.currentLumCount anpassen
        // prüft auf unterhalb
        if (
          toAdd > 0 &&
          (lumieres[lumieres.length-1].getJointPositionWorld() + (toAdd * pub.minLumDistanceWorld)) <= pub.mastHeightWorldMax - (pub.bottomLumMarginmm * pub.mmToWorldUnit)
        ) {

          /**Array.<OLIVIO.LumData>*/ var _lums = lumieres.filter(function (lum) { return lum.lumVisible; });
          /**Array.<OLIVIO.LumData>*/ var _lumsPool = lumieres.filter(function (lum) { return !lum.lumVisible; });
          /**Array.<OLIVIO.LumData>*/ var sortedRot = _lums.slice(0).sort(function(a,b) {
            return a.lumRotationCombined - b.lumRotationCombined;
          });

          // größte lücke suchen
          var lastRot = sortedRot[sortedRot.length-1].lumRotationCombined;
          var biggestRot = 0;
          var biggestRotStart = 0;
          if(sortedRot.length > 2) {
            for (var i = 0; i < sortedRot.length; i++) {
              var d = i === 0 ?
              360 - lastRot + sortedRot[0].lumRotationCombined :
              sortedRot[i].lumRotationCombined - lastRot;

              //console.log('+-------- setLumCount searching hole: ', i+' ("'+(1+sortedRot[i].modelIndex)+'")', lastRot, sortedRot[i].lumRotationCombined, 'biggest '+biggestRot, d>biggestRot, d);

              if (d > biggestRot) {
                biggestRot = d;
                biggestRotStart = i === 0 ?
                  sortedRot[sortedRot.length - 1].lumRotationCombined :
                  sortedRot[i-1].lumRotationCombined;
              }

              lastRot = sortedRot[i].lumRotationCombined;
            }
          } else if (sortedRot.length > 1) { // 2
            biggestRot = sortedRot[1].lumRotationCombined - sortedRot[0].lumRotationCombined;
            biggestRotStart =  sortedRot[0].lumRotationCombined;
            if(biggestRot < 180) {
              biggestRotStart =  sortedRot[1].lumRotationCombined;
              biggestRot = 360- biggestRot;
            }
          } else { // 1
            biggestRotStart =  sortedRot[0].lumRotationCombined;
            biggestRot = 360 - 45;
          }

          var lastRotationCombined = biggestRotStart;
          var deltaRot = biggestRot / (8-oldLumCount +1);

          var lastPos = lumieres[lumieres.length-1].getJointPositionWorld();
          while(toAdd > 0) { // Wert wurde eingangs geprüft
            toAdd--;
            lastPos += pub.minLumDistanceWorld;
            lastRotationCombined += deltaRot;

            var lum = _lumsPool.shift();

            lum.lumVisible = true;
            lum.lumType = lumieres[lumieres.length-1].lumType; // FIXME use lumtype from model if set
            lum.updateFromTypeChange();
            lum.setJointPositionWorld(lastPos);
            lum.lumRotationCombined = (360 + lastRotationCombined) % 360;
            lum.sideLumReload = true;

            //console.log('+-------- setLumCount +'+(toAdd+1), (360 + lastRotationCombined) % 360, ' delta '+deltaRot);

            _lums.push(lum);
          }

          if(_lumsPool.length>0) {
            lumieres = _lums.slice(0,-1).concat(_lumsPool);
            lumieres.push(_lums[_lums.length-1]);
            //console.log('+-------- setLumCount: _lumsPool not empty, so moved it in: ', lumieres, _lums);
          } else {
            lumieres = _lums;
            //console.log('+-------- setLumCount: _lumsPool empty: ', lumieres);
          }

          pub.singleSelectedLum = lumieres.length-1;

        }  else  {
          if(toAdd > 0) {
            //FIXME try harder to search some place. this is about vertical placement
            console.log('\n+-------- setLumCount WARNING: ignored adding Lums in advanced mode due to placement\n');
          }
          pub.currentLumCount = oldLumCount;
        }
      }

      updateModelIndex();

      //pub.minLumDistanceWorld

      lumChangeHandler();
    } else {
      console.log('+-------- _not_ isAdvancedMode, lessLums: '+lessLums);
      updateVisibility(1);
      updateLumPositions();
      updateLumRotations();
      pub.setFirstAndLastLumSelected(); // calls lumChangeHandler();
    }

    this.mastSelected = false;
    mastChangeHandler();

    console.log('setLumCount FIN '+count + '('+(count === parseInt(count))+'): '+oldLumCount + ' => ' + pub.currentLumCount);
    angularHandler();
  };





  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^////////////////////////////////////////////////////






  var updateVisibility = function (arrangingReason) {
    console.log('updateVisibility');
    var possibleLums = pub.currentLumCount;

    // crazy code: zuerst wird an einem Ende des Arrays auf true gesetzt, dann vom anderen Ende her aufgefüllt
    switch(arrangingReason) {
      case OLIVIO.ClampLine.AREATOP:
        //console.log('v-- updateVisibility arrangingReason: AREATOP', lumieres, lumieres[6], lumieres[6].lumVisible);
        if(possibleLums>1) { // beide Enden müssen gesetzt sein, wenn es nur eine lum gibt, dann der höchste index
          lumieres[0].lumVisible = true;
          possibleLums--;
        } else {
          lumieres[0].lumVisible = false;
        }
        console.log(0+': '+lumieres[0].lumVisible);
        for (var i = (lumieres.length - 1); i >= 1; i--) {
            lumieres[i].lumVisible = (possibleLums > 0);
            console.log(i+': '+lumieres[i].lumVisible);
            possibleLums--;
        }
        break;
      case OLIVIO.ClampLine.AREABOTTOM:
        //console.log('v-- updateVisibility arrangingReason: AREABOTTOM', lumieres, lumieres[6], lumieres[6].lumVisible);

        lumieres[lumieres.length - 1].lumVisible = true; // beide Enden müssen gesetzt sein, wenn es nur eine lum gibt, dann der höchste index
        possibleLums--;
        for (var k = 0; k <= lumieres.length - 2; k++) {
            lumieres[k].lumVisible = (possibleLums > 0);
            //console.log(k+': '+lumieres[k].lumVisible);
            possibleLums--;
        }
        break;
      case OLIVIO.ClampLine.AREARIGHT:
        //console.log('v-- updateVisibility arrangingReason AREARIGHT: no operation', lumieres, lumieres[6], lumieres[6].lumVisible);
            // NOP
            break;
      default:
        //console.log('v-- updateVisibility arrangingReason //unknonw// '+arrangingReason+' ∉ {'+OLIVIO.ClampLine.AREATOP+','+OLIVIO.ClampLine.AREABOTTOM+','+OLIVIO.ClampLine.AREARIGHT+'}: no operation', lumieres, lumieres[6], lumieres[6].lumVisible);
    }
    //console.log('+-- updateVisibility before updateModelIndex', lumieres, lumieres[6], lumieres[6].lumVisible);
    updateModelIndex();
    //console.log('^-- updateVisibility', lumieres, lumieres[6], lumieres[6].lumVisible);
  };

  var updateModelIndex = function () {
    // FIXME hier wird ein ModelIndex geführt, aber in design.js der cmodel-index
    var mIndex = 0;
    for (var q = 0; q < lumieres.length; q++) {
      if (lumieres[q].lumVisible === true) {
        lumieres[q].modelIndex = mIndex;
        mIndex++;
      }
    }
  };

  pub.getModelIndexForLum = function (lumId) {
    return lumieres[lumId].modelIndex;
  };

  var updateOneLevelState = function () {
    var oldLumsOnOneLevel = pub.lumsOnOneLevel;
    pub.lumsOnOneLevel = (pub.bottomLumPositionWorld - pub.topLumPositionWorld) * pub.worldUnitTomm < pub.minLumDistancemm;
    if(!oldLumsOnOneLevel && pub.lumsOnOneLevel && pub.product !== OLIVIO.PRODUCT_CANDELABRA) // TODO sollte auch nicht passieren, wenn model geladen wurde, sondern nur, wenn sich die Flanke aus dem Zusammenschieben der Flanke ergibt (statt Test auf CANDELABRA)
      pub.currentLumCount = Math.min(pub.currentLumCount, pub.getMaxPossibleLums());
  };

  /** get maximum count of possible lums dending on product equals candelabra or rotation and lums height boundary
   *
   * @returns {Number} count of possible lums
   */
  pub.getMaxPossibleLums = function () {
    //console.log('getMaxPossibleLums',
    //  (pub.product === pub.CANDELABRA) ? 'candelabra => 3':'not candelabra',
    //  (pub.lumsOnOneLevel === true) ? 'lumsOnOneLevel => ' + getPossibleLumsForRotation(topToBottomRotation) : 'not lumsOnOneLevel',
    //  'boundary: '+ getPossibleLumsForBoundarymm(Math.round((pub.bottomLumPositionWorld - pub.topLumPositionWorld) * pub.worldUnitTomm)),
    //  'rotation: '+ getPossibleLumsForRotation(topToBottomRotation)
    //);

    if (pub.product === OLIVIO.PRODUCT_CANDELABRA) {
      return 3;
    }

    if (pub.lumsOnOneLevel === true) {
      return getPossibleLumsForRotation(topToBottomRotation);
    } else {
      var maxLumsByPosition = getPossibleLumsForBoundarymm(Math.round((pub.bottomLumPositionWorld - pub.topLumPositionWorld) * pub.worldUnitTomm));
      var maxLumsByRotation = getPossibleLumsForRotation(topToBottomRotation);
      return Math.min(maxLumsByPosition, maxLumsByRotation);
    }

  };


  return pub;
}());
